import { render, staticRenderFns } from "./DefaultStatusList.vue?vue&type=template&id=5ffc336e&scoped=true&"
import script from "./DefaultStatusList.vue?vue&type=script&lang=js&"
export * from "./DefaultStatusList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultStatusList.vue?vue&type=style&index=0&id=5ffc336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc336e",
  null
  
)

export default component.exports